import { useMemo } from 'react';
import type { WidgetLibraryImages } from './widget-library-images-map';

type WidgetPromoConfig = {
  [K in keyof WidgetLibraryImages]: {
    promoEndDate?: Date;
    promoImage: keyof WidgetLibraryImages[K];
    show?: boolean;
  };
};

const analyticsWidgetPromoEndDate = new Date('06/30/2025');

export const useWidgetPromo = () => {
  return useMemo(() => {
    return {
      'call-intel-unhappy-calls-widget': {
        promoEndDate: analyticsWidgetPromoEndDate,
        promoImage: 'large-wide',
      },
      'call-intel-scheduling-opportunities-widget': {
        promoEndDate: analyticsWidgetPromoEndDate,
        promoImage: 'small-wide',
      },
      'call-intel-unscheduled-widget': {
        promoEndDate: analyticsWidgetPromoEndDate,
        promoImage: 'large-wide',
      },
    } satisfies Partial<WidgetPromoConfig>;
  }, []);
};
